(function() {
  if (window.daceinCategoryDialogReady) return;
  window.daceinCategoryDialogReady = true;

  var activeDrawer = null;
  var returnFocus = null;
  var closeTimer = null;

  function syncTriggers(isOpen) {
    document.querySelectorAll('[data-category-drawer-open]').forEach(function(button) {
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  function finishClose(drawer) {
    clearTimeout(closeTimer);
    closeTimer = null;
    if (drawer.open) drawer.close();
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('category-drawer-open');
    syncTriggers(false);
    if (returnFocus && returnFocus.isConnected) returnFocus.focus({ preventScroll: true });
    returnFocus = null;
    activeDrawer = null;
  }

  function closeDrawer() {
    if (!activeDrawer || closeTimer) return;
    var drawer = activeDrawer;
    drawer.classList.remove('is-open');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      finishClose(drawer);
    } else {
      closeTimer = window.setTimeout(function() { finishClose(drawer); }, 220);
    }
  }

  function initDrawer(drawer) {
    if (!drawer || drawer.dataset.dialogReady) return;
    drawer.dataset.dialogReady = 'true';
    drawer.addEventListener('cancel', function(event) {
      event.preventDefault();
      closeDrawer();
    });
    drawer.addEventListener('close', function() {
      if (activeDrawer === drawer) finishClose(drawer);
    });
  }

  document.addEventListener('click', function(event) {
    var trigger = event.target.closest('[data-category-drawer-open]');
    if (trigger) {
      var drawer = document.getElementById('CategoryDrawer');
      if (!drawer || typeof drawer.showModal !== 'function') return;
      event.preventDefault();
      initDrawer(drawer);
      if (drawer.open) return;
      returnFocus = trigger;
      activeDrawer = drawer;
      drawer.showModal();
      document.documentElement.classList.add('category-drawer-open');
      syncTriggers(true);
      drawer.querySelector('.category-drawer__close').focus({ preventScroll: true });
      window.requestAnimationFrame(function() {
        if (drawer.open && !closeTimer) drawer.classList.add('is-open');
      });
      return;
    }

    if (!activeDrawer || !activeDrawer.contains(event.target)) return;
    if (event.target.closest('[data-category-drawer-close]')) {
      closeDrawer();
      return;
    }
    var expand = event.target.closest('.category-drawer__expand');
    if (!expand) return;
    var row = expand.closest('.category-drawer__row');
    var nested = row && row.nextElementSibling;
    if (!nested) return;
    var wasExpanded = expand.getAttribute('aria-expanded') === 'true';
    if (!wasExpanded) {
      Array.from(row.parentElement.parentElement.children).forEach(function(item) {
        var siblingRow = item.firstElementChild;
        var siblingButton = siblingRow && siblingRow.querySelector('.category-drawer__expand');
        var siblingList = siblingRow && siblingRow.nextElementSibling;
        if (siblingButton && siblingButton !== expand && siblingList) {
          siblingButton.setAttribute('aria-expanded', 'false');
          siblingList.classList.add('is-collapsed');
        }
      });
    }
    expand.setAttribute('aria-expanded', wasExpanded ? 'false' : 'true');
    nested.classList.toggle('is-collapsed', wasExpanded);
    expand.scrollIntoView({ block: 'nearest' });
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && activeDrawer) {
      event.preventDefault();
      closeDrawer();
    }
  });

  document.addEventListener('shopify:section:unload', function(event) {
    if (activeDrawer && event.target.contains(activeDrawer)) finishClose(activeDrawer);
  });
})();